import React from 'react';
import { Chrome, Bot } from 'lucide-react';
import { useState } from 'react';
import { WaitlistDialog } from '@/components/WaitlistDialog';
import { SHOW_CHROME_BUTTON } from '@/config/features';
import { trackEvent } from '@/lib/analytics';

const NavigationButtons = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <nav className="flex flex-col sm:flex-row justify-center gap-4 mb-8 animate-fadeIn">
      {SHOW_CHROME_BUTTON && (
        <a
          href="https://chromewebstore.google.com/detail/ai-sidebar-with-deepseek/inhcgfpbfdjbjogdfjbclgolkmhnooop"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackEvent("extension_click", { location: "navigation_buttons" })}
          className="inline-flex items-center justify-center px-8 py-4 text-base font-medium rounded-full text-white bg-[#0066FF] hover:bg-[#0066FF]/90 transition-all shadow-[0_4px_14px_0_rgba(0,102,255,0.39)] hover:shadow-[0_6px_20px_rgba(0,102,255,0.23)] hover:transform hover:translate-y-[-1px]"
        >
          <Chrome className="mr-2 h-5 w-5" aria-hidden="true" />
          Add to Chrome - It's Free
        </a>
      )}
      <button
        onClick={() => {
          trackEvent("cta_click", { cta: "create_ai_agents", location: "navigation_buttons" });
          setIsDialogOpen(true);
        }}
        className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#0066FF] text-base font-medium rounded-full text-[#0066FF] bg-white hover:bg-blue-50 transition-all shadow-[0_4px_14px_0_rgba(0,102,255,0.39)] hover:shadow-[0_6px_20px_rgba(0,102,255,0.23)] hover:transform hover:translate-y-[-1px]"
      >
        Create AI Agents
        <Bot className="ml-2 h-5 w-5" aria-hidden="true" />
      </button>
      
      <WaitlistDialog 
        isOpen={isDialogOpen} 
        onClose={() => setIsDialogOpen(false)} 
      />
    </nav>
  );
};

export default NavigationButtons;
